import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'gatsby'
import { get, isEmpty } from 'lodash'
import CollapseButton from './CollapseButton'
import styles from './swagger-api.module.css'

export default function Xerrors2({ x_errors_2, title }) {
  const [isOpen, setIsOpen] = useState(true)

  if (!x_errors_2 || x_errors_2.length === 0) {
    return null
  }
  return (
    <div className="dax-more-error" id="errors" data-cy="errors2">
      <div className={styles.attributesHeading}>
        <h3 className="dx-anchor">
          <Link to="#errors" aria-hidden="true" />
          Error messages
        </h3>
        <CollapseButton onClick={() => setIsOpen(!isOpen)} isOpen={isOpen} />
      </div>
      {isOpen && (
        <>
          <p>
            In addition to{' '}
            <Link to="/api/rest/responses/#http-status-codes">
              common HTTP status codes
            </Link>{' '}
            that the REST APIs return, the {title} API can return the following
            errors.
          </p>
          <ul className="dax-messages error-2" data-cy="errors2-list">
            {x_errors_2.map((currError, index1) => {
              return (
                <li key={index1}>
                  <>
                    <h4>
                      <Link className="dx-anchor__icon" aria-hidden="true" />
                      <code>{currError.name}</code>
                    </h4>
                    <ReactMarkdown
                      source={`${currError.message} ${
                        !isEmpty(currError.issues) ? 'Possible issues are' : ''
                      }`}
                      escapeHtml={false}
                    />
                    {get(currError, 'issues').length ? (
                      <>
                        <ul className="dax-messages error-2 issues">
                          {currError.issues &&
                            currError.issues.map((currErrorIssue, index3) => {
                              return (
                                <li
                                  id="issue-{currErrorIssue.issue}"
                                  key={index3}
                                >
                                  <h4 className="dx-anchor">
                                    <code>{currErrorIssue.issue}.</code>
                                  </h4>
                                  <p>{currErrorIssue.description}</p>
                                </li>
                              )
                            })}
                        </ul>
                      </>
                    ) : null}
                  </>
                </li>
              )
            })}
          </ul>
        </>
      )}
    </div>
  )
}
